export default __webpack_public_path__ + "static/media/utas_logo.e24f41d6.svg";